export const versions = {
  version: "1.0.183",
  revision: "1a7c774b7",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5329-g1a7c774b7-dirty",
    hash: "g1a7c774b7",
    distance: 5329,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5329-g1a7c774b7-dirty",
    semverString: "1.0.183+5329.g1a7c774b7.dirty"
  }
};
